import styled from 'styled-components';
import { device } from '../../constants';
import React from 'react';

interface DivProps extends React.HTMLProps<HTMLDivElement> {}

export const VerticalBox: React.FC<DivProps> = ({ children, ...props }) => {
  return <BoxStyle {...props}>{children}</BoxStyle>;
};

const BoxStyle = styled.div`
  padding: 100px 0;
  @media screen and ${device.lg} {
    padding: 70px 0;
  }
  @media screen and ${device.md} {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  @media screen and ${device.sm} {
    padding: 40px 0;
  }
`;
